import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button, FilterUtils } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';
import { useFiltersContext } from '@spotahome/ui-library/src/tenant/context/FiltersContext';

import SortBy from '../SortBy';

import { generateTitleElems, generateTitleElemsSimplified } from './utils';

import './SearchTitle.scss';

const noop = () => {};

const SearchTitle = ({
  totalResults = 0,
  currentPageResults = null,
  onSortChange = noop,
  cityName,
  onClearFilters = noop,
  showButtons = true,
  size = 'small'
}) => {
  const { filters } = useFiltersContext();
  const topology = filters['topology[]'];

  const shouldShowClearFiltersButton = () => {
    const activeFiltersCount = FilterUtils.getActiveFiltersCount(filters);
    return activeFiltersCount > 0 && totalResults !== 0;
  };

  /**
   * We need filtersNoPropertyType to show pattern h1 for SEO.
   * We will pass the empty type array to mock the default filter.
   * We are renaming move-in and move-out to the expected from the function
   */
  const {
    'type[]': types,
    'move-in': moveIn,
    'move-out': moveOut,
    ...filtersNoPropertyType
  } = filters;

  const titleClassname = classNames('search-title__title', {
    'search-title__title--big': size === 'big',
    'search-title__title--small': size === 'small'
  });

  const totalResultsText =
    currentPageResults !== null
      ? trans('search.results.totals', {
          currentResults: currentPageResults,
          totalResults
        })
      : totalResults;

  return (
    <div className="search-title">
      {FilterUtils.isDefaultFilterFromUrl({
        ...filtersNoPropertyType,
        moveIn,
        moveOut,
        'type[]': []
      }) && types.length <= 1 ? (
        <h1
          className={titleClassname}
          data-test="search-title"
          dangerouslySetInnerHTML={{
            __html: generateTitleElemsSimplified(
              types,
              cityName,
              totalResultsText
            )
          }}
        />
      ) : (
        <h1 className={titleClassname} data-test="search-title">
          <strong data-test="search-title-total-count">
            {totalResultsText}
          </strong>{' '}
          {generateTitleElems(types, cityName, topology)}
        </h1>
      )}

      {showButtons ? (
        <div className="search-title__summary">
          {shouldShowClearFiltersButton() ? (
            <Button
              color="select"
              alt
              size="small"
              onClick={onClearFilters}
              className="search-title__clear"
              data-test="title-filters-summary-clear-button"
            >
              {trans('search.filters.clear.cta')}
            </Button>
          ) : null}

          <SortBy handleSortByChange={onSortChange} orderBy={filters.sortBy} />
        </div>
      ) : null}
    </div>
  );
};

SearchTitle.propTypes = {
  currentPageResults: PropTypes.number,
  totalResults: PropTypes.number,
  onSortChange: PropTypes.func,
  cityName: PropTypes.string.isRequired,
  onClearFilters: PropTypes.func,
  showButtons: PropTypes.bool,
  size: PropTypes.string
};

export default SearchTitle;
